import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import CommonDeleteModal from "../../../../../core/common/modal/commonDeleteModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { EditOutlined } from "@ant-design/icons";
import AddUserToPackage from "./AddUserToPackage";
import { Select, Spin } from "antd";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import NewPayment from "../Payments/NewPayment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const CRMInvoices = () => {
  const [invoiceStatusOptions, setInvoiceStatusOptions] = useState([]);

  const getInvoiceStatuses = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}invoice/GetInvoiceStatus`);

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.InvoiceStatus,
        }));

        setInvoiceStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const invoiceStatusCards = [
    {
      id: 1,
      name: "Draft",
      textClass: "text-info",
      bgClass: "bg-info",
      icon: "fa-file-pen",
    },
    {
      id: 2,
      name: "Paid",
      textClass: "text-success",
      bgClass: "bg-success",
      icon: "fa-circle-check",
    },
    {
      id: 3,
      name: "Unpaid",
      textClass: "text-danger",
      bgClass: "bg-danger",
      icon: "fa-file-invoice-dollar",
    },
    {
      id: 4,
      name: "Partially Paid",
      textClass: "text-warning",
      bgClass: "bg-warning",
      icon: "fa-money-bill-transfer",
    },
    {
      id: 5,
      name: "Cancelled",
      textClass: "text-dark",
      bgClass: "bg-dark",
      icon: "fa-triangle-exclamation",
    },
  ];

  const [payDrawerOpen, setPayDrawerOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const columns = [
    {
      title: "Invoice #",
      dataIndex: "invoice_no",

      render: (_, record) => {
        // const color =
        //   invoiceBadgeColors[record.status] || invoiceBadgeColors.Default;

        return (
          <Link
            to={`/crm/view/invoice`}
            state={{ record }}
            className="text-decoration-none"
          >
            <span
              className={``}
              // style={{
              //   fontSize: "13px",
              //   borderRadius: "8px",
              // }}
            >
              <i className="fa-regular fa-file-lines text-info me-2"></i>
              {record.prefix || ""}
              {record.number || ""}
            </span>
          </Link>
        );
      },
    },
    {
      title: "Customer",
      dataIndex: "ClientName",

      render: (_, record) => {
        // const clientName = record.ClientName || "Unknown Customer";

        // const initials = clientName
        //   .split(" ")
        //   .filter(Boolean)
        //   .slice(0, 2)
        //   .map((x) => x[0])
        //   .join("")
        //   .toUpperCase();

        // const avatarStyles = [
        //   { bg: "#E7F1FF", color: "#0D6EFD" },
        //   { bg: "#E8F8F0", color: "#198754" },
        //   { bg: "#FFF4E5", color: "#FD7E14" },
        //   { bg: "#F3E8FF", color: "#6F42C1" },
        //   { bg: "#E6FFFB", color: "#0D6EFD" },
        //   { bg: "#FCE7F3", color: "#D63384" },
        // ];

        // const style =
        //   avatarStyles[clientName.charCodeAt(0) % avatarStyles.length];

        return (
          <div className="d-flex align-items-start">
            {/* <Avatar
              size={42}
              style={{
                background: style.bg,
                color: style.color,
                fontWeight: 700,
                border: `1px solid ${style.color}20`,
              }}
            >
              {initials || "?"}
            </Avatar> */}

            <div className="ms-3">
              <div className="fw-semibold">
                {" "}
                <i className="fa-solid fa-building me-2 text-dark"></i>
                {record.ClientName || "N/A"}
              </div>

              <small className="text-muted">
                <i className="fa-solid fa-folder-open me-2"></i>
                {record.ProjectName || "N/A"}
              </small>
            </div>
          </div>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "total",

      render: (_, record) => (
        <>
          <div className="fw-semibold text-success">
            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
            {record.total}
          </div>

          <small className="text-muted">
            <i className="fa-solid fa-percent me-2"></i>
            Tax : {record.total_tax}
          </small>
        </>
      ),
    },

    // {
    //   title: "Tags",
    //   dataIndex: "tags",

    //   render: (tags) => (
    //     <Tag
    //       color="blue"
    //       bordered={false}
    //       style={{
    //         borderRadius: 20,
    //         padding: "4px 12px",
    //         marginBottom: 5,
    //         fontWeight: 500,
    //       }}
    //       className="d-flex align-items-center"
    //     >
    //       <i className="fa-solid fa-tag me-2"></i>
    //       {tags?.map((tag) => (
    //         <div key={tag}>
    //           {tag}, {` `}
    //         </div>
    //       ))}
    //     </Tag>
    //   ),
    // },

    {
      title: "Invoice Date",
      dataIndex: "date",
      render: (date) => (
        <>
          <div>
            <i className="fa-regular fa-calendar me-2 text-primary"></i>
            {date ? dayjs(date).format("DD/MM/YYYY") : "-"}
          </div>
        </>
      ),
    },

    {
      title: "Due Date",
      dataIndex: "duedate",

      render: (duedate) => {
        if (!duedate) {
          return "-";
        }

        const due = dayjs(duedate);
        const today = dayjs().startOf("day");
        const days = due.startOf("day").diff(today, "day");

        return (
          <>
            <div>
              <i className="fa-regular fa-calendar-check me-2 text-primary"></i>
              {due.format("DD/MM/YYYY")}
            </div>

            <small
              className={
                days < 0
                  ? "text-danger"
                  : days <= 7
                    ? "text-warning"
                    : "text-success"
              }
            >
              <i className="fa-regular fa-clock me-2"></i>

              {days < 0
                ? `${Math.abs(days)} days overdue`
                : days === 0
                  ? "Due today"
                  : `${days} days left`}
            </small>
          </>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#0d6efd";

            case "Paid":
              return "#198754";

            case "Partially Paid":
              return "#ffc107";

            case "UnPaid":
              return "#dc3545";

            case "Cancelled":
              return "#dc3545";

            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              invoiceStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 120 }}
            options={invoiceStatusOptions}
            onChange={(value) => {
              updateInvoiceStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = invoiceStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                className="dropdown-item"
                to={`/crm/view/invoice`}
                state={{ record }}
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                to={`/crm/update/invoice/${record.id}`}
                className="dropdown-item"
              >
                <Edit className="me-2 text-primary" />
                Edit
              </Link>
            </li>
            <li>
              {record?.StatusName !== "Paid" &&
                record?.StatusName !== "Cancelled" && (
                  <Link
                    to="#"
                    className="dropdown-item"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedInvoice(record);
                      setPayDrawerOpen(true);
                    }}
                  >
                    <CreditCard className="me-2 text-success" />
                    Payment
                  </Link>
                )}
            </li>
  
          </ul> */}
          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                title="Edit"
                to={`/crm/update/invoice/${record.id}`}
                className="text-primary me-2 p-2"
              >
                {/* <i className="ti ti-pencil-alt text-primary"></i> */}
                <EditOutlined />
              </Link>

              {record?.StatusName !== "Paid" &&
                record?.StatusName !== "Cancelled" && (
                  <Link
                    title="Payment"
                    to="#"
                    className="me-2 p-2"
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedInvoice(record);
                      setPayDrawerOpen(true);
                    }}
                  >
                    <i className="ti ti-credit-card text-success"></i>
                  </Link>
                )}
            </div>
          </div>
        </>
      ),
    },
  ];
  // const Customer = [
  //   { label: 'Carl Evans', value: '1' },
  //   { label: 'Minerva Rameriz', value: '2' },
  //   { label: 'Robert Lamon', value: '3' },
  // ]

  // const Status = [
  //   { label: 'Paid', value: '1' },
  //   { label: 'Unpaid', value: '2' },
  //   { label: 'Robert Lamon', value: '3' },
  // ]

  const [invoiceCounts, setInvoiceCounts] = useState([]);

  const [invoice, setInvoice] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(0);

  const [invoiceLoading, setInvoiceLoading] = useState(false);

  console.log(invoiceCounts, invoice, invoiceLoading);
  const [exportLoading, setExportLoading] = useState(false);

  const fetchInvoiceCounts = async () => {
    try {
      const response = await axios.get(
        `${BASE_CRM_URL}invoice/GetInvoiceCounts?clientid=122`,
      );

      if (response.data?.Status) {
        setInvoiceCounts(response.data.ResultData || []);
      } else {
        setInvoiceCounts([]);
      }
    } catch (error) {
      console.error("Error fetching invoice counts:", error);
      setInvoiceCounts([]);
    }
  };

  const fetchInvoice = async (status = 0) => {
    try {
      setInvoiceLoading(true);

      const response = await axios.get(`${BASE_CRM_URL}invoice/GetInvoices`, {
        params: {
          Status: status,
        },
      });

      if (response.data?.Status) {
        setInvoice(response.data.ResultData || []);
      } else {
        setInvoice([]);
      }
    } catch (error) {
      console.error("Get Estimates Error:", error);
      setInvoice([]);
    } finally {
      setInvoiceLoading(false);
    }
  };

  const updateInvoiceStatus = async (InvoiceId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}invoice/UpdateInvoiceStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: InvoiceId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        fetchInvoice(0); // Reload your proposal list
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const handleStatusChange = ({ key }) => {
  //   const statusId = Number(key);

  //   fetchInvoice(statusId);
  // };
  // const statusDropdownItems = [
  //   {
  //     key: "0",
  //     label: "All",
  //   },
  //   ...invoiceStatusOptions.map((status) => ({
  //     key: String(status.value),
  //     label: status.label,
  //   })),
  // ];
  //   const getInvoiceCount = (statusId) => {
  //     const status = invoiceCounts.find(
  //       (item) => item.StatusId === statusId
  //     );

  //     return {
  //       count: status?.Count || 0,
  //       total: status?.TotalCount || 0,
  //     };
  //   };

  //   const draft = getInvoiceCount(1);
  // const paid = getInvoiceCount(2);
  // const unpaid = getInvoiceCount(3);
  // const partiallyPaid = getInvoiceCount(4);
  // const cancelled = getInvoiceCount(5);

  useEffect(() => {
    fetchInvoiceCounts();
    fetchInvoice(0);
    getInvoiceStatuses();
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const exportExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Invoice");

      // Columns
      worksheet.columns = [
        { header: "Invoice#", key: "InvoiceNo", width: 25 },
        { header: "Company", key: "ClientName", width: 25 },
        { header: "Project", key: "ProjectName", width: 32 },
        { header: "Amount", key: "total", width: 18 },
        { header: "Created", key: "datecreated", width: 18 },
        { header: "Due", key: "duedate", width: 18 },
        { header: "Status", key: "StatusName", width: 18 },
      ];

      // Add data
      invoice.forEach((estimate) => {
        worksheet.addRow({
          InvoiceNo: estimate.InvoiceNo ?? "",
          ClientName: estimate.ClientName ?? "",
          ProjectName: estimate.ProjectName ?? "",
          total: estimate.total ?? "",
          datecreated: estimate.datecreated ?? "",
          duedate: estimate.duedate ?? "",

          StatusName: estimate.StatusName || "N/A",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      headerRow.height = 22;

      // Borders and alignment
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Invoice.xlsx");
    } catch (error) {
      console.error("Excel export error:", error);

      Swal.fire("Error", "Failed to generate Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Invoice#",
        "Company",
        "Project",
        "Amount",
        "Created",
        "Due",
        "Status",
      ];

      const rows = invoice.map((invoice) => [
        invoice.InvoiceNo ?? "",
        invoice.ClientName ?? "",
        invoice.ProjectName ?? "",

        invoice.total ?? "",
        invoice.datecreated ?? "",

        invoice.duedate || "N/A",
        invoice.StatusName || "N/A",

        // estimate.dateadded
        //   ? new Date(estimate.dateadded).toLocaleString("en-IN")
        //   : "",
      ]);

      // Report title - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Invoice Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 6,
          right: 6,
        },

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        didDrawPage: () => {
          // Footer center
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Total pages
      const totalPages = doc.internal.getNumberOfPages();

      // Page X of Y
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Invoice.pdf");
    } catch (error) {
      console.error("PDF export error:", error);

      Swal.fire("Error", "Failed to generate PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        {exportLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/crm/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Invoices
                    </h4>
                  </ol>
                </nav>
                <p className="text-muted">Manage and add new invoices</p>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={exportPDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={exportExcel}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="/crm/add/invoice"
                className="btn btn-success btn-sm me-2"
              >
                <i className="ti ti-circle-plus fs-4 "> </i>
              </Link>
              {/* <Link
                to="#"
                className="btn btn-dark"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasAddUserToPackage"
              >
                <PlusCircle data-feather="plus-circle" className=" me-1" />
                Package
              </Link> */}
            </div>
          </div>
          <div className="row g-3">
            {invoiceStatusCards.map((card) => {
              const status = invoiceCounts.find(
                (item) => item.StatusId === card.id,
              );

              const count = status?.Count || 0;
              const total = status?.TotalCount || 0;

              return (
                <div className="col-12 col-sm-6 col-xl d-flex" key={card.id}>
                  <div
                    className={`card flex-fill shadow-sm ${
                      selectedStatus === card.id ? "border-primary" : ""
                    }`}
                    onClick={() => {
                      setSelectedStatus(card.id);
                      fetchInvoice(card.id);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                      <div className="d-flex align-items-center gap-2 text-nowrap">
                        <h4 className="mb-0 fw-bold">
                          {count}/{total}
                        </h4>

                        <p className={`mb-0  fw-semibold`}>{card.name}</p>
                      </div>

                      <div
                        className={`rounded-circle ${card.bgClass} bg-opacity-10 d-flex align-items-center justify-content-center`}
                        style={{
                          width: 45,
                          height: 45,
                        }}
                      >
                        <i
                          className={`fa-solid ${card.icon} ${card.textClass} fs-4`}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* /product list */}
          <div className="card table-list-card ">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Select
                    placeholder="Status"
                    style={{ width: 150 }}
                    value={selectedStatus}
                    onChange={(value) => {
                      setSelectedStatus(value);
                      fetchInvoice(value);
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All",
                      },
                      ...invoiceStatusOptions,
                    ]}
                  />
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className=" table-responsive">
                {invoiceLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px", // adjust height if needed
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : (
                  <Table columns={columns} dataSource={invoice} />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <NewPayment
          open={payDrawerOpen}
          setOpen={setPayDrawerOpen}
          record={selectedInvoice}
        />
        <CommonFooter />
      </div>
      <AddUserToPackage />
      <CommonDeleteModal />
    </div>
  );
};

export default CRMInvoices;
